import { reactive, inject } from 'vue';

import DefaultImports from 'lg-vue-components/utils/defaultImports';
import BreakMonitor from 'lg-vue-components/mixins/breakMonitor';
import { getPathName } from 'lg-vue-components/utils';
import { atualizeUrlBase } from 'lg-vue-components/services/axiosRequest';

const defaultOptions = {
  produto: '',
  rotaPadrao: '',
  modoAberturaRota: 'path',
  cdn: {
    urlBase: process.env.VUE_APP_CDN,
    versao: process.env.VUE_APP_CDN_VERSAO,
  },
  urls: {
    base: getPathName(),
    produto: new URL('./Produtos', window.location).href,
  },
  zIndex: {
    menu: 99999,
    sidebar: 1000,
    navbar: 1000,
  },
};

const LGSymbol = Symbol('LGVueComponents');

export function useLGVueComponents() {
  const LGVueComponents = inject(LGSymbol);

  if (!LGVueComponents) {
    throw new Error('LGVueComponents não foi configurado corretamente!');
  }

  return LGVueComponents;
}

export default {
  install: (app, options) => {
    let configOptions = { ...defaultOptions };

    if (options) {
      configOptions = { ...defaultOptions, ...options };
      configOptions.cdn = { ...defaultOptions.cdn, ...(options.cdn || {}) };
      configOptions.urls = { ...defaultOptions.urls, ...(options.urls || {}) };
      configOptions.zIndex = { ...defaultOptions.zIndex, ...(options.zIndex || {}) };
    }

    const LGVueComponents = {
      config: reactive(configOptions),
    };

    /* eslint-disable */
    app.config.globalProperties.$lg = app.config.globalProperties.$lg || {};
    app.config.globalProperties.$lg = { ...LGVueComponents };
    /* eslint-enable */

    atualizeUrlBase(app.config.globalProperties.$lg.config.urls.base);

    app.provide(LGSymbol, LGVueComponents);

    DefaultImports(app);
    app.use(BreakMonitor);
  },
};
